import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { me as apiMe, login as apiLogin, signup as apiSignup } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("wpe_token");
    if (!token) {
      setLoading(false);
      return;
    }
    apiMe()
      .then((u) => setUser(u))
      .catch(() => {
        localStorage.removeItem("wpe_token");
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const data = await apiLogin(email, password);
    localStorage.setItem("wpe_token", data.access_token);
    setUser(data.user);
    return data.user;
  };

  const signup = async (email, password) => {
    const data = await apiSignup(email, password);
    localStorage.setItem("wpe_token", data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("wpe_token");
    setUser(null);
  };

  const value = useMemo(
    () => ({ user, setUser, loading, login, signup, logout }),
    [user, loading]
  );
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
